import { Box, Tooltip } from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ETheme } from "../../../shared/enums/user/ETheme";
import { formatPrice } from "../../../shared/functions/formatPrice";
import { EditIcon, NotePadIcon } from "../../../shared/icons/Icons";
import { darkTheme, lightTheme } from "../../../shared/mui/theme";
import { RootState } from "../../../store/store";

export const useModuleColumns = (hideActionColumn = false): GridColDef[] => {
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  return [
    { field: "id", headerName: t("general.id"), width: 80 },
    {
      field: "name",
      headerName: t("module.name"),
      flex: 1,
      minWidth: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => {
            navigate(`/module/update/${params?.row?.id}`);
          }}
        >
          {t(`modules.${params.value}`)}
        </div>
      ),
    },
    {
      field: "description",
      headerName: t("general.note"),
      width: 100,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div
          style={{ display: "flex", alignItems: "center", height: "100%" }}
          className={"cursor-pointer"}
        >
          {params?.value && (
            <Tooltip title={params?.value ?? ""}>
              <div style={{ display: "flex" }}>
                <NotePadIcon
                  fill={
                    userData?.theme === ETheme.LIGHT
                      ? lightTheme.palette.text.primary
                      : darkTheme.palette.text.primary
                  }
                />
              </div>
            </Tooltip>
          )}
        </div>
      ),
    },

    {
      field: "price",
      headerName: t("general.price"),
      width: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {formatPrice(params.value)}
        </div>
      ),
    },

    {
      field: "actions",
      headerName: t("general.action"),
      width: 150,
      sortable: false,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <Box
          sx={{
            display: hideActionColumn ? "none" : "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Edit or View Icon */}
          <span
            style={{ cursor: "pointer", display: "flex" }}
            onClick={() => {
              navigate(`/module/update/${params?.row?.id}`);
            }}
          >
            <EditIcon
              fill={
                userData?.theme === ETheme.LIGHT
                  ? lightTheme.palette.text.primary
                  : darkTheme.palette.text.primary
              }
            />
          </span>
        </Box>
      ),
    },
  ];
};
